import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box as CotopaxiBox } from '@as/cotopaxi';
import { CaretLeftIcon } from '@yonderland/andes-icons';
import { Box, Icon, Stack } from '@yonderland/andes-react';
export const ProductDetailTab = ({ id, isExpanded, title, onClick, children }) => {
    const handleKeyDown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ')
            return;
        event.preventDefault();
        onClick();
    };
    return (_jsxs(Box, { id: id, children: [_jsx("div", { "aria-expanded": isExpanded, "aria-haspopup": "dialog", onClick: onClick, onKeyDown: handleKeyDown, role: "button", tabIndex: 0, children: _jsx(CotopaxiBox, { interactive: true, mobile: { spacing: { paddingTop: 2.5, paddingBottom: 2.5 } }, children: _jsxs(Stack, { direction: "row", gap: "0", justify: "between", align: "center", children: [title, _jsx(Icon, { source: CaretLeftIcon, size: "sm" })] }) }) }), children] }));
};
